import TapuService from "./TapuService/index.ts";

export default class Services {
    tapuService: TapuService;

    constructor() {
        this.tapuService = new TapuService();
    }
}
